export default "__VITE_ASSET__LFnxJBq4__"